import { html } from "lit";
import { customElement, property, state } from "lit/decorators.js";
import { BaseElement } from "../BaseElement";
import { styles } from "./SketchFabEmbedControl.style";
import { makeCustomEvent } from "../../Utils";
import { LightTheme } from "../ThemeLight";

@customElement("ds-sketchfab-embed-control")
export class SketchFabEmbedControl extends BaseElement {
    static override styles = [styles];
    @property({ type: String }) propName: any;

    override render() {
        return html` <div class="container">
            <sl-input
                @sl-input=${(e: Event) =>
                    this._raiseEvent("ds-changed", {
                        url: (e.target as any).value,
                    })}
                title="Enter YouTube embed link"
            ></sl-input>
        </div>`;
    }
}

export function showSketchFabEmbedDialog(props: any, approved: any, cancelled: any = () => {}) {
    const dialog = Object.assign(document.createElement("ds-sketchfab-embed-dialog"), props);
    dialog.addEventListener("ds-on-accept", (e: CustomEvent) => {
        approved(e.detail.url);
    });
    dialog.addEventListener("on-cancel", () => {
        cancelled();
    });
    document.body.append(dialog);
}

@customElement("ds-sketchfab-embed-dialog")
export class SketchFabEmbedDialog extends BaseElement {
    static override styles = [styles, LightTheme];
    @state() protected _url: string | undefined;

    private _validate(url: string) {
        try {
            const u = new URL(url);
            return ["sketchfab.com"].includes(u.hostname);
        } catch {
            return false;
        }
    }

    override render() {
        return html`<ds-entry-dialog
            open
            label="Enter SketchFab URL"
            ?isValid=${!!this._url}
            @on-accept=${(e: CustomEvent) => {
                e.stopPropagation();
                if (this._url) {
                    const id = this._url.slice(-32);
                    if (id) {
                        this.dispatchEvent(
                            makeCustomEvent("ds-on-accept", {
                                url: `https://sketchfab.com/models/${id}/embed`,
                            })
                        );
                    }
                }
            }}
        >
            <ds-sketchfab-embed-control
                @ds-changed=${(e: CustomEvent) => {
                    if (this._validate(e.detail.url)) {
                        this._url = e.detail.url;
                    } else {
                        this._url = undefined;
                    }
                }}
            ></ds-sketchfab-embed-control>
        </ds-entry-dialog>`;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        "ds-sketchfab-embed-control": SketchFabEmbedControl;
        "ds-sketchfab-embed-dialog": SketchFabEmbedDialog;
    }
}
